module.exports = require("core-js/modules/esnext.global-this.js");